import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export type DeleteCreditData = object;

@Component({
  selector: 'admin-delete-credit-modal',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './delete-credit-modal.component.html',
  styleUrls: ['./delete-credit-modal.component.scss'],
})
export class DeleteCreditModalComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteCreditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteCreditData,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
